import React from 'react'

const About_Us_Area_Start = () => {
  return (
    <div>
      
      <section class="about-us-area py-100 rpb-90 rel z-1">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-5 col-lg-6">
                        <div class="about-us-content rmb-55" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">
                            <div class="section-title mb-25">
                                <h2 className='work'>Travel with Confidence Top Reasons to Choose Our Agency</h2>
                            </div>
                            <p style={{color:'white'}}>We go above and beyond to make your travel dreams reality hidden gems and must-see attractions</p>
                            <div class="divider counter-text-wrap mt-45 mb-55"><span>We have <span><span class="count-text plus" data-speed="3000" data-stop="25">0</span> Years</span> of experience</span></div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="counter-item counter-text-wrap">
                                        <span class="count-text k-plus work" data-speed="3000" data-stop="3">0</span>
                                        <span class="counter-title work work">Popular Destination</span>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="counter-item counter-text-wrap">
                                        <span class="count-text m-plus work" data-speed="3000" data-stop="9">0</span>
                                        <span class="counter-title work">Satisfied Clients</span>
                                    </div>
                                </div>
                            </div>
                            <a href="/Destination" class="theme-btn mt-10 style-two ">
                                <span data-hover="Explore Destinations work">Explore Destinations</span>
                                <i class="fal fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-7 col-lg-6" data-aos="fade-right" data-aos-duration="1500" data-aos-offset="50">
                        <div class="about-us-image">
                            <div class="shape"><img src="assets/images/about/shape1.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape2.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape3.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape4.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape5.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape6.png" alt="Shape" /></div>
                            <div class="shape"><img src="assets/images/about/shape7.png" alt="Shape" /></div>
                            <img src="https://images.pexels.com/photos/2104044/pexels-photo-2104044.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default About_Us_Area_Start
